import { useState, useRef, useEffect, useContext } from 'react';
import Util from 'lib/util';
import Select from 'react-select';

function AppSelect(props) {
  const { options, value, change, customStyles, selectNone } = props;
  const [valueItem, setValueItem] = useState({});
  const [items, setItems] = useState([]);
  const [bool, setBool] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    //数据处理
    let arr = Util.clone(options);

    //兼容[{id: '',text: ''}]格式选项
    arr.forEach(item => {
      if (!item.value) {
        item.value = item.id;
      }
      if (!item.label) {
        item.label = item.text;
      }
    });

    if (selectNone === true && !arr.map(item => item.value).includes('-1')) {
      arr.unshift({
        value: '-1',
        label: '-- 请选择 --'
      });
    }
    setItems(arr);
    let obj = {};
    arr.forEach(item => {
      if (item.value === value || String(item.value) === String(value)) {
        obj = item;
      }
    });

    setValueItem(obj);

    //IOS
    const userAgent = window.navigator.userAgent;
    setIsIOS(/iPhone|iPad|iPod/i.test(userAgent));
  }, [options, value, selectNone]);

  function onChange(event) {
    if (Util.isEmpty(event)) {
      return;
    }
    let item = Object.assign({}, event);
    if (item.value === '-1') {
      item.value = '';
    }
    change(item);
  }

  function onFocus(event) {
    if (isIOS) {
      return;
    }
    //Android
    setBool(false);
    setTimeout(() => {
      setBool(true);
    }, 200);
  }

  return (
    <div>
      <Select
        options={items}
        onChange={onChange}
        noOptionsMessage={() => {
          return '无数据';
        }}
        menuPosition={'fixed'}
        value={valueItem}
        styles={customStyles}
        maxMenuHeight={200}
        onFocus={onFocus}
        isSearchable={!isIOS}
        placeholder="-- 请选择 --"
      />
    </div>
  );
}

export default AppSelect;
